<template>
<div>
  <div v-show="mostraMenu" class="sidebar-wrapper" :style=[widthStyle,sideBarStyle]>      
      <h2>{{titleApp}}</h2>
      <div v-if="hasRole('admin-enquesta')"><router-link to="/admin/enquestes">{{$t('menu.enquesta')}}</router-link></div>
      <!-- <div v-if="hasRole('direccio')"><router-link to="/admin/direccio">{{$t('menu.direccio')}}</router-link></div> -->
      <div v-if="hasRole('admin-usuari')"><router-link to="/admin/usuaris">{{$t('menu.usuari')}}</router-link></div>
      <div v-if="hasRole('admin-audit')"><router-link to="/admin/audit">{{$t('menu.audit')}}</router-link></div>
      <div v-if="hasRole('direccio')"><router-link to="/admin/direccioEnquesta">{{$t('menu.direccioEnquesta')}}</router-link></div>
      <div v-if="hasRole('admin-usuari')"><router-link to="/admin/fitxa">{{$t('menu.fitxa')}}</router-link></div>
      <div v-if="hasRole('direccio')">
        <a href="/ManualMonitor.pdf" target="_blank"><span style='padding-left: 20px'><strong>Manual d'ús</strong></span></a>
      </div>
      <div>
        <b-button size="sm" variant="primary" class="mb-2" @click.prevent="logout">
          <b-icon icon="power" aria-hidden="true"></b-icon> {{$t('menu.logout')}}
        </b-button>
      </div>    
  </div>

  <!-- App header -->
  <div class="app-header" :style=[appHeaderStyle]>
    <div v-show="userLogged && mostraMenu" class="app-header-menu m-3">
      <a href="javscript:void(0)" @click.prevent="toggleMenu" class="toogle-menu-link">
        <b-icon icon="list" font-scale="2"/>
      </a>
    </div>
    <div class="app-header-title m-2">
        <img v-bind:src=logoApp>
    </div>
    <div v-show="true" class="app-header-language m-3">
      <b-dropdown right variant="outline-info" size="sm">
        <template slot="button-content">
          {{locale}}
        </template>
        <b-dropdown-item v-for="language in languages" :key="language.locale" @click.prevent="changeLanguage(language.locale)">          
        {{ language.title }}
        </b-dropdown-item>
      </b-dropdown>
    </div>
  </div>
  
</div>
</template>
<script>
import { i18n } from '@/plugins/i18n';
import loginService from "../services/LoginService";
export default {
  name: 'MenuSideBar',
  props: {
    width: {
      type: Number,
      required: true
    },
    userLogged: {
      type: Boolean,
      required: true
    }    
  },
  data () {
    return {
      locale: 'ca',
      toogled : false,
      sideBarStyle : {        
        'margin-left': '-'+this.width+'rem'
      },     
      appHeaderStyle : {
        'left': '0'
      }
    }
  },
  computed: {
    titleApp(){
      return process.env.VUE_APP_TITLE;
    },
    logoApp(){
      return process.env.VUE_APP_BASE_URL+process.env.VUE_APP_LOGO_PATH;
    },    
    languages() {
      return [
        { locale: 'es', title: this.$t('castella') },
        { locale: 'ca', title: this.$t('catala') }
      ]
    },
    widthStyle: function () {
      return {'width': this.width+'rem'}
    },
    mostraMenu: function () {
      return this.userLogged && (loginService.hasRole('admin-enquesta')||loginService.hasRole('direccio')||loginService.hasRole('admin-usuari')||loginService.hasRole('admin-audit'));
    }   
  }, 
  methods: {
    changeLanguage(locale) {
      i18n.locale = locale;
      this.locale = locale;      
    },
    toggleMenu() {
        if(this.toogled){
            this.closeMenu()
        }else{
            this.openMenu()
        }
    },    
    openMenu() {
      let ml = this.width+'rem';
      this.sideBarStyle = {'margin-left': 0}     
      this.appHeaderStyle = {'left': ml}
      this.toogled = true;
    },
    closeMenu() {
      let ml = this.width+'rem';
      this.sideBarStyle = {'margin-left': '-'+ml}
      this.appHeaderStyle = {'left': 0}
      this.toogled = false;
    },    
    logout(){
      this.closeMenu();      
      loginService.logout();      
      
    },
    hasRole(roleName){
      return loginService.hasRole(roleName);
    }
  }
}    
</script>
<style scoped>
.sidebar-wrapper {
  min-height: 100vh;
  background-color: rgb(37, 39, 51);
  box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.1);
  transition: all 0.4s;
  padding: 1.5rem !important;
  text-align: center;
}
.app-header {
  position: fixed;
  top: 0;
  min-width: 100vw;
  height: 60px;
  align-content: center;  
  transition: all 0.4s;
  background-color: white;
  box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.1); 
  display: flex;
  text-align: center;
  z-index: 10;  
}
.app-header-menu {
  top: 0;    
  width: auto;  
}
.app-header-title {
  width: 100%;
  text-align: center;
  align-items: center;    
}
.app-header-language {
  width: auto;
  align-items: center;
  right: 0;
  position: absolute      
}
</style>
